import React, { useState, useEffect, ReactNode } from "react";
import { AuthContext, User } from "./AuthContext";

export function AuthProvider({ children }: { children: ReactNode }) {
    const [user, setUser] = useState<User | null>(() => {
        const savedUser = localStorage.getItem("user");
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const [token, setToken] = useState<string | null>(() => {
        return localStorage.getItem("token");
    });

    const [currentDietId, setCurrentDietId] = useState<string | null>(() => {
        return localStorage.getItem("currentDietId");
    });

    const [selectedDietType, setSelectedDietType] = useState<string | null>(null);

    // Persist authentication state
    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            localStorage.removeItem("user");
        }
    }, [user]);

    useEffect(() => {
        if (token) {
            localStorage.setItem("token", token);
        } else {
            localStorage.removeItem("token");
        }
    }, [token]);

    useEffect(() => {
        if (currentDietId) {
            localStorage.setItem("currentDietId", currentDietId);
        } else {
            localStorage.removeItem("currentDietId");
        }
    }, [currentDietId]);

    const authFetch = async (url: RequestInfo, options?: RequestInit) => {
        return fetch(url, {
            ...options,
            headers: {
                ...options?.headers,
                Authorization: `Bearer ${token}`,
            },
        });
    };

    const value = {
        user,
        setUser: (newUser: User | null) => {
            setUser(newUser);
            if (!newUser) {
                setToken(null);
            }
        },
        token,
        setToken: (newToken: string | null) => {
            setToken(newToken);
            if (!newToken) {
                setUser(null);
            }
        },
        currentDietId,
        setCurrentDietId,
        selectedDietType,
        setSelectedDietType,
        isAuthenticated: !!user && !!token,
        isAdmin: user?.role === "admin",
        authFetch,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
